import { defineComponent as _defineComponent } from 'vue'
import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import Tabs from "@/components/common/Tabs.vue";
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'BetDetails',
  setup(__props) {

const { $t } = useTranslation();

const showAccountSelectionModal = ref(false);
const tabs = ref([
  { id: "page details", name: $t("Bet Details") },
  { id: "user stake", name: $t("User Stake") },
]);

const route = useRoute();
const router = useRouter();

const selectedTab = computed({
  get() {
    return route.name || tabs.value[0].id;
  },
  set(value: string) {
    router.push({ name: value, query: route.query });
  },
});

function handleTabInput(val: string) {
  selectedTab.value = val;
}

return { __sfc: true,$t, showAccountSelectionModal, tabs, route, router, selectedTab, handleTabInput, UserBreadcrumb, Tabs, AccountSelectModal, AccountSelectSearch }
}

})